import { useLiveContext } from '@app/modules/Live/contexts/Live.Context'
import { selectedFeatureAtom, selectedLayerAtom } from '@app/risk-migration/atoms/riskMap.atoms'
import { useRiskMapNavigation } from '@app/risk-migration/hooks/useRiskMapNavigation'
import type { MapLayer } from '@app/types/layerTypes'
import { useAtomValue } from 'jotai'
import { useEffect } from 'react'
import { GroupedLayers } from '..'
import { EmptySideDrawer } from '../../EmptyTab'
import { LiveSelectedTabBody } from './LiveSelectedTabBody/LiveSelectedTabBody'
import { SpecificLocationAccordion } from './SpecificLocationAccordion'
export const SelectedTab = ({ groupedLayers }: { groupedLayers: GroupedLayers }) => {
  // Add location specific details
  const selectedFeature = useAtomValue(selectedFeatureAtom)
  const selectedLayer = useAtomValue(selectedLayerAtom)
  const { liveMapSelected, selectedLiveFeatures } = useLiveContext()
  const { flyToFeature } = useRiskMapNavigation()
  const selectedGeoJSONFeature = selectedFeature as mapboxgl.MapboxGeoJSONFeature

  // fly to selected feature
  useEffect(() => {
    if (selectedFeature) {
      flyToFeature(selectedFeature as GeoJSON.Feature, {
        essential: true,
        duration: 2000,
        usePadding: true,
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedFeature])

  if (selectedGeoJSONFeature && selectedGeoJSONFeature.layer?.source) {
    if (selectedLayer?.layerType === 'live') {
      return <LiveSelectedTabBody selectedLiveFeatures={selectedLiveFeatures} />
    }
    const maplayerListOfHazardLayers = groupedLayers.hazards.reduce((acc, hazardGroup) => {
      return [...acc, ...hazardGroup.scenarios.map((scenario) => scenario.layer)]
    }, [] as MapLayer[])
    return (
      <>
        <SpecificLocationAccordion
          selectedFeature={selectedGeoJSONFeature}
          selectedAsset={selectedLayer}
          assetLayers={groupedLayers.assets}
          hazardLayers={maplayerListOfHazardLayers}
          informationLayers={groupedLayers.information}
        />
      </>
    )
  }
  if (groupedLayers.assets.length > 0) {
    return <EmptySideDrawer text="Click an element on the map to get insights here" type="select" />
  }
  return (
    <EmptySideDrawer
      text={
        liveMapSelected
          ? 'Add layers to start building your operating picture'
          : 'No elements are visible on the map. Add elements to gain insights'
      }
      type="element"
      buttonText={liveMapSelected ? 'Add Live Data' : 'Add Elements'}
    />
  )
}
